import { Card, Col, Row, Table, Tabs, Select, Form } from 'antd'
import DateCell from '../../../elements/Table/Cells/DateCell'
import MoneyCell from '../../../elements/Table/Cells/MoneyCell'
import CustomTable from '../../../elements/Table/CustomTable'
import _, { get } from 'lodash'
import React, { Fragment, useState } from 'react'
import SumFooter from '../../../elements/Table/Footers/SumFooter'

const TabPane = Tabs.TabPane

const TableSummary = ({ data, title, keyID }) => {
  return !!data ? (
    <Card title={_.startCase(title)} style={{ margin: 'auto', marginBottom: 15 }}>
      {Object.keys(data).map(function (indexKey) {
        const value = keyID ? _.get(data[indexKey], keyID) : data[indexKey]
        return (
          <Row gutter={16} style={{ marginBottom: 5 }}>
            <Col span={10} style={{ fontWeight: 'bold' }}>
              {_.startCase(indexKey)}
            </Col>
            <Col span={14}>{value}</Col>
          </Row>
        )
      })}
    </Card>
  ) : (
    <Fragment />
  )
}

function BASSummary(props) {
  const { data } = props
  const [currencyVoucer, setCurrencyVoucer] = useState(true)
  const [currencyInvoice, setCurrencyInvoice] = useState(true)

  if (!get(data, 'startDate')) {
    let collectedTotal = get(data, 'collected.total')
    let collectedSummary = get(data, 'collected.summary')
    const paidTotal = get(data, 'paid.total')
    let paidSummary = get(data, 'paid.summary')
    let dataVouchers = get(data, 'paid.vouchers', []).reduce(
      (arr, elem) =>
        arr.concat(
          elem.taxSummary.map((m) => {
            return { ...elem, taxSummary: m }
          })
        ),
      []
    )

    let dataInvoices = get(data, 'collected.invoices', []).reduce(
      (arr, elem) =>
        arr.concat(
          elem.taxSummary.map((m) => {
            return { ...elem, taxSummary: m }
          })
        ),
      []
    )

    return (
      <Fragment>
        {!!collectedSummary && (
          <Tabs defaultActiveKey="1">
            <TabPane tab="Collected Summary" key="1">
              <TableSummary title={'Collected Total'} data={collectedTotal} />
              <Table
                dataSource={collectedSummary}
                columns={[
                  {
                    title: 'Tax Type',
                    dataIndex: 'type',
                    key: 'type',
                  },
                  {
                    title: 'Net',
                    dataIndex: 'net',
                    key: 'net',
                  },
                  {
                    title: 'Gross',
                    dataIndex: 'gross',
                    key: 'gross',
                  },
                  {
                    title: 'Tax',
                    dataIndex: 'tax',
                    key: 'tax',
                  },
                  {
                    title: 'Declared',
                    dataIndex: 'declared',
                    key: 'declared',
                  },
                ]}
              />
            </TabPane>
            <TabPane tab="Invoices" key="2">
              <Select defaultValue={true} value={currencyInvoice}
                      onChange={(e) => setCurrencyInvoice(e)}>
                <Select.Option value={true}>Show In Reporting Currency</Select.Option>
                <Select.Option value={false}>Show Original</Select.Option>
              </Select>
              <CustomTable
                columns={[
                  { Header: 'Code', accessor: 'code' },
                  { Header: 'Client', accessor: 'member.fn', hideable:true, hideDefault: false},
                  { Header: 'Date', accessor: 'date', Cell: DateCell },
                  { Header: 'Status', accessor: 'status', hideable:true, hideDefault: false},
                  { Header: 'Type', accessor: 'type', hideable:true, hideDefault: true },
                  {
                    Header: 'Currency',
                    accessor: currencyInvoice ? 'currency' : 'originalCurrency'
                  },
                  {
                    Header: 'Conversion Rate',
                    accessor: `conversion`,
                    Cell: MoneyCell
                  },
                  {
                    Header: 'Net',
                    accessor: `${currencyInvoice ? 'taxSummary' : 'originalTaxSummary'}.net`,
                    Cell: MoneyCell,
                    Footer: SumFooter,
                  },
                  {
                    Header: 'Gross',
                    accessor: `${currencyInvoice ? 'taxSummary' : 'originalTaxSummary'}.gross`,
                    Cell: MoneyCell,
                    Footer: SumFooter,
                  },
                  {
                    Header: 'Tax',
                    accessor: `${currencyInvoice ? 'taxSummary' : 'originalTaxSummary'}.tax`,
                    Cell: MoneyCell,
                    Footer: SumFooter,
                  },
                  {
                    Header: 'Declared',
                    accessor: `${currencyInvoice ? 'taxSummary' : 'originalTaxSummary'}.declared`,
                    Cell: MoneyCell,
                    hideable: true,
                    hideDefault: true
                  },
                  {
                    Header: 'Tax Type',
                    accessor: `${currencyInvoice ? 'taxSummary' : ''}.type`
                  },
                ]}
                data={dataInvoices}
                show={{
                  csv: {
                    fileName: 'BAS-Collected',
                  },
                }}
              />
            </TabPane>
          </Tabs>
        )}

        {!!paidSummary && (
          <Tabs defaultActiveKey="1">
            <TabPane tab="Paid Summary" key="1">
              <TableSummary title={'Paid Total'} data={paidTotal} />
              <Table
                dataSource={paidSummary}
                columns={[
                  {
                    title: 'Tax Type',
                    dataIndex: 'type',
                    key: 'type',
                  },
                  {
                    title: 'Net',
                    dataIndex: 'net',
                    key: 'net',
                  },
                  {
                    title: 'Gross',
                    dataIndex: 'gross',
                    key: 'gross',
                  },
                  {
                    title: 'Tax',
                    dataIndex: 'tax',
                    key: 'tax',
                  },
                  {
                    title: 'Declared',
                    dataIndex: 'declared',
                    key: 'declared',
                  },
                ]}
              />
            </TabPane>
            <TabPane tab="Vouchers" key="2">
              <Form.Item label="Curreny">
                <Select defaultValue={true} value={currencyVoucer} onChange={(e) => setCurrencyVoucer(e)}>
                  <Select.Option value={true}>Show In Reporting Currency</Select.Option>
                  <Select.Option value={false}>Show Original</Select.Option>
                </Select>
              </Form.Item>
              <CustomTable
                columns={[
                  { Header: 'Code', accessor: 'code' },
                  { Header: 'Vendor', accessor: 'member.fn',
                    Cell: ({ value }) => value && (value).toUpperCase(),
                    style: { alignment: "left", marginLeft:5 },
                    hideable:true,hideDefault:false, width:400
                  },
                  { Header: 'Date', accessor: 'date', Cell: DateCell },
                  { Header: 'Type', accessor: 'type' },
                  { Header: 'Currency', accessor: currencyVoucer ? 'currency' : 'originalCurrency' },
                  { Header: 'Conversion Rate', accessor: `conversion`, Cell: MoneyCell },

                  {
                    Header: 'Net',
                    accessor: `${currencyVoucer ? 'taxSummary' : 'originalTaxSummary'}.net`,
                    Cell: MoneyCell,
                    Footer: SumFooter,
                  },
                  {
                    Header: 'Gross',
                    accessor: `${currencyVoucer ? 'taxSummary' : 'originalTaxSummary'}.gross`,
                    Cell: MoneyCell,
                    Footer: SumFooter,
                  },
                  {
                    Header: 'Tax',
                    accessor: `${currencyVoucer ? 'taxSummary' : 'originalTaxSummary'}.tax`,
                    Cell: MoneyCell,
                    Footer: SumFooter,
                  },
                  {
                    Header: 'Declared',
                    accessor: `${currencyVoucer ? 'taxSummary' : 'originalTaxSummary'}.declared`,
                    Cell: MoneyCell,
                    hideable: true,
                    hideDefault: true
                  },
                  { Header: 'Tax Type', accessor: `${currencyVoucer ? 'taxSummary' : ''}.type` },
                ]}
                data={dataVouchers}
                show={{
                  csv: {
                    fileName: 'BAS_Paid',
                  },
                }}
              />
            </TabPane>
          </Tabs>
        )}
      </Fragment>
    )
  } else {
    return <Fragment />
  }
}

export default BASSummary
